'use client';

import { Box, Group, Skeleton, Stack, type StackProps } from '@mantine/core';
import useIsMobile from '@/lib/is-mobile/use-is-mobile';
type Props = StackProps;
export default function PromoItemLoading({ ...props }: Props) {
  const isMobile = useIsMobile();

  return (
    <Stack gap={8} {...props} style={{}}>
      {Array.from({ length: 3 }).map((_, index) => (
        <Box
          key={index}
          style={{
            position: 'relative',
          }}
        >
          <Box
            pos="absolute"
            style={{
              height: 32,
              width: 32,
              backgroundColor: '#fff',
              top: '50%',
              left: -16,
              transform: 'translateY(-50%)',
              zIndex: 40,
              borderRadius: '50%',
              borderRight: '1px solid #eee',
              borderTopRight: '1px solid #eee',
              borderBottomRight: '1px solid #eee',
            }}
          />
          <Box
            style={{
              height: '98px',
              // border: '1px solid #eee',
              borderRadius: 4,
            }}
          >
            <Group
              styles={{
                root: {
                  flex: 'flex-none',
                  flexWrap: 'nowrap',
                },
              }}
            >
              <Box>
                <Skeleton width={98} height={98} radius={4} />
              </Box>
              <Stack justify="space-between" pr={8}>
                <Group
                  justify="space-between"
                  style={{
                    width: isMobile ? 'calc(100vw - 152px)' : 270,
                  }}
                >
                  <Skeleton height={12} width="20%" radius="xl" />
                  <Skeleton height={12} width="20%" radius="xl" />
                </Group>
                <Skeleton height={12} width="80%" radius="xl" />
                <Group justify="space-between">
                  <Skeleton height={12} width="40%" radius="xl" />
                  <Skeleton height={12} width="20%" radius="xl" />
                </Group>
              </Stack>
            </Group>
          </Box>
        </Box>
      ))}
    </Stack>
  );
}
